import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, DatePicker, Form, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { axiosErrorHandler, isConcurrentModificationError } from "../../../../swzutils";
import dayjs from "dayjs";
const ConsignmentDetailsModal = (props) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    useEffect(() => {
        if (props.open && props.consignment) {
            // Clear previous error messages
            setErrorMessage(null);
        }
    }, [props.open, props.consignment]);
    const patchDelivery = (formValues) => {
        setLoading(true);
        axios.patch(`/admin/v1/consignments/${props.consignment.id}`, {
            customerRef: formValues.customerRef ? formValues.customerRef : '',
            salesOrderRef: formValues.salesOrderRef ? formValues.salesOrderRef : '',
            orderDate: formValues.orderDate ? formValues.orderDate.format("YYYY-MM-DD") : null,
            clearOrderDate: !formValues.orderDate,
            version: props.consignment.version,
            pickUpPhotoRequired: formValues.pickUpPhotoRequired,
            completionPhotoRequired: formValues.completionPhotoRequired,
            completionSignatureRequired: formValues.completionSignatureRequired
        }).then(response => {
            props.onUpdated(response.data);
        }).catch(error => {
            if (isConcurrentModificationError(error)) {
                setErrorMessage("The delivery date could not be updated. This is because another user has updated the same consignment.  Please refresh the consignment list and try again.");
            }
            else {
                axiosErrorHandler(error, setErrorMessage);
            }
        }).finally(() => setLoading(false));
    };
    return (_jsxs(Modal, { title: "Update Delivery Details", open: props.open, okText: "Update", onOk: form.submit, onCancel: () => {
            setErrorMessage(null);
            props.onCancel();
        }, confirmLoading: loading, destroyOnHidden: true, children: [_jsxs(Form, { form: form, onFinish: patchDelivery, layout: "vertical", initialValues: {
                    'salesOrderRef': props.consignment?.salesOrderRef,
                    'customerRef': props.consignment?.customerRef,
                    'orderDate': (props.consignment?.orderDate)
                        ? dayjs(props.consignment.orderDate, "YYYY-MM-DD")
                        : null,
                }, children: [_jsx(Form.Item, { name: "salesOrderRef", label: "Order Reference", rules: [
                            { max: 20, message: 'Please limit the order reference to 20 characters.' }
                        ], children: _jsx(Input, { maxLength: 20 }) }), _jsx(Form.Item, { name: "orderDate", label: "Order Date", children: _jsx(DatePicker, { showTime: false, format: "DD/MM/YYYY", allowClear: true }) }), _jsx(Form.Item, { name: "customerRef", label: "Customer Reference", rules: [
                            { max: 50, message: 'Please limit the customer reference to 50 characters.' }
                        ], children: _jsx(Input, { maxLength: 50 }) })] }), errorMessage &&
                _jsx("div", { style: { marginTop: "20px" }, children: _jsx(Alert, { type: "error", title: errorMessage, banner: true }) })] }));
};
export default ConsignmentDetailsModal;
